import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const useRedirectIfNotLoggedIn = (
  openedViaLogin,
  delay = 50,
  redirectPath = "/"
) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!openedViaLogin) {
      const timeoutId = setTimeout(() => {
        // Pass state only if redirectPath is not "/"
        if (redirectPath === "/") {
          navigate(redirectPath);
        } else {
          navigate(redirectPath, { state: { openedViaButton: true } });
        }
      }, delay);

      return () => clearTimeout(timeoutId);
    }
  }, [openedViaLogin, navigate, delay, redirectPath]);
};

export default useRedirectIfNotLoggedIn;
